import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2';
import axios from "axios";
import QuestionContents from './UI/QuestionContents';
import { useAuth } from '../../../../../context/AuthContext';
import { useParams } from "react-router-dom";
import './matchcss.css';
import 'quill/dist/quill.snow.css';
import useSubjectName from './useSubjectName';
import useAttemptTracker, { MAX_FRONTEND_ATTEMPTS } from './useAttemptTracker';
import { API_BASE_URL } from '../../../../../Helpers/apiConfig';

const TrueFalse = (props) => {
    const { t } = useTranslation();
    const [msg, setMsg] = useState([]);
    const [question, setQuestion] = useState([]);
    const [answers, setAnswers] = useState([]);
    const [questionTitle, setQuestionTitle] = useState([]);
    const [questionText, setQuestionText] = useState([]);

    // Seçili butonları takip etmek için yeni state
    const [selectedValues, setSelectedValues] = useState({});

    const { user } = useAuth();
    const params = useParams();
    const subjectName = useSubjectName();
    const { getAttempt, registerWrongAttempt, clearAttempt } = useAttemptTracker(props.questionNumber);

    const Request = async (userAnswer) => {
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            };
            let url = `${API_BASE_URL}/user/Content/Answer`;
            await axios({
                method: 'POST',
                url: url,
                params: {
                    courseId: Number(params.courseid),
                    question: Number(props.data.id),
                    answer: userAnswer.toString()
                },
                headers: headerss
            }).then(res => {
                clearAttempt();
                if (res.data['success']) {
                    props.playCorrectSound?.();
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    }).then(() => {
                        let newurl = Number(params['id']) + 1;
                        window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                    });
                }
                else {
                    if (res.data['alertType'] === "question") {
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hatalı cevap",
                            text: props.data.notfyText,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                    else {
                        let errorMsg = res['data']['message'];
                        props.playLastIncorrectSound?.();
                        Swal.fire({
                            title: "Hata",
                            text: errorMsg,
                            icon: "error",
                            confirmButtonText: `Tamam`,
                        }).then(() => {
                            let newurl = Number(params['id']) + 1;
                            window.location.href = "/user/course/question/" + params['courseid'] + "/" + params['subjectid'] + "/" + newurl;
                        });
                    }
                }
            });
        } catch (err) {
            setMsg(err.message);
        }
    };

    const answerTrueFalseHandle = async (e) => {
        e.preventDefault();
        let userAnswer = "";
        for (let i = 0; i < props.truefalseanswercount; i++) {
            const trueEl = document.getElementById(i + ".true");
            const falseEl = document.getElementById(i + ".false");

            if (trueEl && trueEl.checked) {
                userAnswer += "true";
            } else if (falseEl && falseEl.checked) {
                userAnswer += "false";
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Lütfen tüm seçenekleri cevaplayın.',
                    confirmButtonText: 'Tamam'
                });
                return;
            }
            if (i < props.truefalseanswercount - 1) userAnswer += ",";
        }

        const attempt = getAttempt();
        const correctAnswer = props.data.answer;

        if (attempt < MAX_FRONTEND_ATTEMPTS - 1) {
            if (userAnswer === correctAnswer) {
                Request(userAnswer);
            } else {
                registerWrongAttempt();
                if (attempt === MAX_FRONTEND_ATTEMPTS - 2) {
                    props.playLastIncorrectSound?.();
                } else {
                    props.playFirstIncorrectSound?.();
                }
                Swal.fire({
                    title: attempt === MAX_FRONTEND_ATTEMPTS - 2 ? "Son bir kez deneyiniz!" : "Tekrar Deneyiniz!",
                    text: props.data.notfyText,
                    icon: "warning",
                }).then(() => window.location.reload());
            }
            return;
        }
        Request(userAnswer);
    };

    const handleButtonClick = (id, value) => {
        // State'i güncelle (Görsellik için)
        setSelectedValues(prev => ({
            ...prev,
            [id]: value
        }));

        // Gizli radyo butonunu güncelle (Mevcut logic'in çalışması için)
        const radio = document.getElementById(id + "." + value);
        if (radio) radio.checked = true;
    };

    useEffect(() => {
        setQuestion(JSON.parse(props.data.contentStr));
        setAnswers(JSON.parse(props.data.detail));
        let que = JSON.parse(props.data.contentStr);
        let questionTitlee = que['text'].split('__')[0];
        let questionTextt = que['text'].split('__')[1];
        setQuestionTitle(questionTitlee);
        setQuestionText(questionTextt);
    }, []);

    return (
        <div>
            <span style={{ color: "black" }}> <b><i>{subjectName}</i></b></span>
            <br />
            <b>True False Sorusu</b>
            <br />
            <div style={{ textAlign: "center" }}>
                <QuestionContents question={question} />
                {!(question?.type === "sound" || question?.type === "video" || question?.type === "image" || question?.type === "image_sound") && (
                    <><br /><br /></>
                )}
                <b style={{ fontSize: "18px", fontFamily: 'calibri', color: "SteelBlue" }}>
                    {questionTitle}
                </b>
            </div>
            <div style={{ textAlign: "left" }}>
                <br /> <br />
                <div
                    className="ql-editor"
                    style={{ fontSize: "18px", fontFamily: 'calibri', color: "black", padding: 0 }}
                    dangerouslySetInnerHTML={{ __html: questionText }}
                />
                <hr />
            </div>

            <form onSubmit={answerTrueFalseHandle} className="tf-form">
                <div className="tf-list">
                    {answers && answers.map((dt) => (
                        <div key={dt.id} className="tf-item" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px', borderBottom: '1px solid #eee' }}>
                            <div className="tf-text" style={{ flex: 1 }}>
                                <b>{dt['service']}</b>
                            </div>

                            <div className="tf-options-buttons" style={{ display: 'flex', gap: '15px' }}>
                                {/* Arka planda çalışan gizli radyo butonları */}
                                <input type="radio" name={"inlineRadioOptions" + dt.id} id={dt.id + ".true"} style={{ display: 'none' }} />
                                <input type="radio" name={"inlineRadioOptions" + dt.id} id={dt.id + ".false"} style={{ display: 'none' }} />

                                {/* True Butonu */}
                                <button
                                    type="button"
                                    onClick={() => handleButtonClick(dt.id, 'true')}
                                    style={{
                                        padding: '10px 25px',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        transition: 'all 0.2s',
                                        border: '2px solid #28a745',
                                        // Seçiliyse dolu, değilse boş tasarım
                                        backgroundColor: selectedValues[dt.id] === 'true' ? '#28a745' : 'white',
                                        color: selectedValues[dt.id] === 'true' ? 'white' : '#28a745'
                                    }}
                                >
                                    True
                                </button>

                                {/* False Butonu */}
                                <button
                                    type="button"
                                    onClick={() => handleButtonClick(dt.id, 'false')}
                                    style={{
                                        padding: '10px 25px',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        transition: 'all 0.2s',
                                        border: '2px solid #dc3545',
                                        // Seçiliyse dolu, değilse boş tasarım
                                        backgroundColor: selectedValues[dt.id] === 'false' ? '#dc3545' : 'white',
                                        color: selectedValues[dt.id] === 'false' ? 'white' : '#dc3545'
                                    }}
                                >
                                    False
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <br /><br />

                {props.answered ? (
                    <div className="tf-answered">
                        <i>{props.realanswer}</i> cevaplanmış soru.
                    </div>
                ) : (
                    <div className="tf-submit">
                        <button type="submit" className="save-btn">
                            {t("saveAndContinue")}
                        </button>
                    </div>
                )}
            </form>
            <hr />
        </div>
    );
};

export default TrueFalse;